<template>
<div class="select-tab-wrapper">
  <div :class="showSettingTab ? 'select-3tab' : 'select-2tab'">
    <button
      class="editor-label"
      :class="{'active':showTabContent}"
      @click="selectTab('Content')"
    >
      {{ displayName }}
    </button>
    <button
      class="style-label"
      v-if="showStyleTab"
      :class="{'active':showTabStyle}"
      @click="selectTab('Style')"
    >
      スタイル
    </button>
    <button
      class="setting-label"
      v-if="showSettingTab"
      :class="{'active':showTabSetting}"
      @click="selectTab('Setting')"
    >
      設定
    </button>
    <button
      class="tag-label"
      v-if="showCodeTagTab"
      :class="{'active':showTabCodeTag}"
      @click="selectTab('Tag')"
    >
      コンテンツ
    </button>
    <div class="underline"></div>
  </div>
</div>
</template>

<script>
export default {
  props: [
    'currentTab',
    'partsContainerType',
    'displayName'
  ],
  computed: {
    showTabContent () {
      return this.currentTab === 'Content'
    },
    showTabStyle () {
      return this.currentTab === 'Style'
    },
    showTabSetting () {
      return this.currentTab === 'Setting'
    },
    showTabCodeTag () {
      return this.currentTab === 'Tag'
    },
    showStyleTab () {
      if (!this.partsContainerType) return null
      return this.partsContainerType !== 'Divider' && this.partsContainerType !== 'Code'
    },
    showSettingTab () {
      if (!this.partsContainerType) return null
      return this.partsContainerType !== 'Divider' && this.partsContainerType !== 'Code'
    },
    showCodeTagTab () {
      if (!this.partsContainerType) return null
      return this.partsContainerType === 'Code'
    },
  },
  methods: {
    selectTab (tab) {
      this.$emit('selectTab', tab)
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin button($width) {
  color: #A7A7A7;
  background: #f8f8f8;
  width: $width;
  height: 40px;
  line-height: 40px;
  border-bottom: #dbdbdb 0.5px solid;
  font-size: 16px;
  cursor: pointer;
}

@mixin underline($width) {
  width: $width;
  height: 1.5px;
  background: #707070;
  position: absolute;
  bottom: -0.5px;
  transition: all 0.2s ease-in-out 0s;
}

@mixin select-tab {
  position: relative;
  margin: 0 20px 20px;
}

.select-tab-wrapper {
  border-top: 1px solid #dbdbdb;
  padding-top: 10px;
  // 2カラムのタブ
  .select-2tab {
    $tabWidth: 50%;
    @include select-tab;
    button {
      @include button($tabWidth);
      &:focus {
        outline: 0;
      }
      &.active, &:hover {
        color: $commonFontColor;
      }
      &.active {
        ~ .underline {
          @include underline($tabWidth);
        }
      }
      &.editor-label.active {
        ~ .underline {
          left: 0%;
        }
      }
      &.style-label.active, &.tag-label.active {
        ~ .underline {
          left: $tabWidth;
        }
      }
    }
  }
  // 3カラムのタブ
  .select-3tab {
    $tabWidth: 33%;
    @include select-tab;
    button {
      @include button($tabWidth);
      &:focus {
        outline: 0;
      }
      &.active, &:hover {
        color: $commonFontColor;
      }
      &.active {
        ~ .underline {
          @include underline($tabWidth);
        }
      }
      &.editor-label.active {
        ~ .underline {
          left: 0%;
        }
      }
      &.style-label.active {
        ~ .underline {
          left: $tabWidth;
        }
      }
      &.setting-label.active {
        ~ .underline {
          left: calc( #{$tabWidth} * 2 );
        }
      }
    }
  }
}
</style>
